// Copy Trading allocation settings
export const allocationMethodFixed = 0; // Ratio
export const allocationMethodEquity = 1; // Equity
export const allocationMethodByEquity = 2; // Equity ratio
export const allocationMethodBalance = 3; // Balance ratio
export const allocationMethods = [allocationMethodFixed, allocationMethodByEquity];
export const allocationPercentDefault = 100;
export const allocationPercentMin = 0.1;
export const allocationPercentMax = 1000;
export const allocationPercentStep = 10;
